/* eslint-disable camelcase, max-len  */
const {
  getFullDate,
  getYear
} = require(`../../../utils/date`);
const COMMERCE_CATEGORIES = [{
  id: 'fashion',
  name: 'Fashion',
  link: 'fashion',
  origin: 'fil-fa',
  weaver_feed: 'shopping-categories-fashion',
  laser_tag: 'fashion',
  products_tag: 'Fashion',
  images: {
    desktop: 'fashion_desktop.png',
    mobile: 'fashion_mobile.png',
    header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/fOpA0nj-6.png',
    header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/9xbbjLP9Ey.png',
    icon_light: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/1Te5gRKnR.png',
    icon_dark: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/e36n5B8Uu.png'
  },
  order: 2,
  meta: {
    name: `Biggest Fashion Deals for ${getFullDate()}`,
    description: 'A curated list of the best articles featuring the latest deals on jeans, tops, dresses, shoes and underwear at the cheapest prices.'
  },
  bg_color: '#323254',
  text_color: '#FFFFFF'
}, {
  id: 'sports-fitness',
  name: 'Sports + Fitness',
  link: 'sports-fitness',
  origin: 'fil-sp',
  weaver_feed: 'shopping-categories-sports-fitness',
  laser_tag: 'sports_fitness',
  products_tag: 'Sports + Fitness',
  images: {
    desktop: 'sports_desktop.png',
    mobile: 'sports_mobile.png',
    header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/WITgD8bts.png',
    header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/Ib-KoMNsW.png',
    icon_light: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/TZaDfe617.png',
    icon_dark: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/wfeiOAP2P.png'
  },
  order: 4,
  meta: {
    name: `Best Sports and Fitness Deals of ${getYear()}`,
    description: 'We curate the best sports goods and fitness deals to find the best running, climbing, cycling, or even extreme ironing gear for you to live your best life.'
  },
  bg_color: '#8CA2E9',
  text_color: '#222222'
}, {
  id: 'home',
  name: 'Home',
  link: 'home',
  origin: 'fil-ho',
  weaver_feed: 'shopping-categories-home',
  laser_tag: 'home',
  products_tag: 'Home',
  images: {
    desktop: 'home_desktop.png',
    mobile: 'home_mobile.png',
    header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/NRGqnQAer.png',
    header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/6G8s_R7QP.png',
    icon_light: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/YL6sfQ9kT.png',
    icon_dark: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/hyCaolCh3.png'
  },
  order: 3,
  meta: {
    name: `Home Decor Deals for ${getFullDate()}`,
    description: 'Home Organization, decor, and design deals brought to you by the curators at BuzzFeed like live and love this stuff.'
  },
  bg_color: '#FFE3D4',
  text_color: '#222222'
}, {
  id: 'tech',
  name: 'Tech',
  link: 'tech',
  origin: 'fil-te',
  weaver_feed: 'shopping-categories-tech',
  laser_tag: 'tech',
  products_tag: 'Tech',
  images: {
    desktop: 'tech_desktop.png',
    mobile: 'tech_mobile.png',
    header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/LginMAuXN.png',
    header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/NHiPUJ2Ye.png',
    icon_light: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/IMDe-vJUD.png',
    icon_dark: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/e2joK1ZBz.png'
  },
  order: 6,
  meta: {
    name: `Best Tech Deals of ${getYear()} from the Biggest Brands`,
    description: 'All the best tech deals curated by our expert team to find the best deals on AirPods, speakers, headphones, or laptop and phone accessories.'
  },
  bg_color: '#B0C1D1',
  text_color: '#222222'
}, {
  id: 'sex-toys',
  name: 'Sex Toys',
  link: 'sex-toys',
  origin: 'fil-se',
  weaver_feed: 'shopping-categories-sex-toys',
  laser_tag: 'sex_toys',
  products_tag: 'Sex Toys',
  images: {
    desktop: 'sextoys_desktop.png',
    mobile: 'sextoys_mobile.png',
    header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/mdmGwb_t8.png',
    header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/ibYN2eetK.png',
    icon_light: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/H7Fi3otSC.png',
    icon_dark: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/e2tv8Rd3ap.png'
  },
  order: 10,
  meta: {
    name: `Best Sex Toy Deals for ${getFullDate()}`,
    description: 'We love sex toys 😘! Vibrators 🍆♒, Dildos 🍆, suction-based 👅, water-based 💦 ....we love them all. We list out all the best sex toy deals for fun while we 👉👌.'
  },
  bg_color: '#F7C597',
  text_color: '#222222'
}, {
  id: 'pets',
  name: 'Pets',
  link: 'pets',
  origin: 'fil-pe',
  weaver_feed: 'shopping-categories-pets',
  laser_tag: 'pets',
  products_tag: 'Pets',
  images: {
    desktop: 'pets_desktop.png',
    mobile: 'pets_mobile.png',
    header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/diFyy1Gy8.png',
    header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/_tCrnsVoC.png',
    icon_light: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/VJR5086IV.png',
    icon_dark: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/pcxjHxfOS.png'
  },
  order: 8,
  meta: {
    name: `Best Pet Products Deals for ${getFullDate()}`,
    description: 'We love pets! Our team has curated the best articles on pet product deals for dogs, cats, birds, or whatever furry friend you love.'
  },
  bg_color: '#F9E57F',
  text_color: '#222222'
}, {
  id: 'beauty-personal-care',
  name: 'Beauty + Personal Care',
  link: 'beauty-personal-care',
  laser_tag: 'beauty_personal_care',
  products_tag: 'Beauty & Personal Care',
  origin: 'fil-be',
  weaver_feed: 'shopping-categories-beauty-personal-care',
  images: {
    desktop: 'beauty_desktop.png',
    mobile: 'beauty_mobile.png',
    header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/NMBw4k8RH.png',
    header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/yt1cLM0Nb.png',
    icon_light: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/Bvh8slOTU.png',
    icon_dark: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/BHJXqrzPJ.png'
  },
  order: 1,
  meta: {
    name: `Beauty and Personal Care Deals For ${getFullDate()}`,
    description: 'A curated list of the best articles on Beauty and Personal Care deals including skin care, acne treatments, lip gloss, teeth whiteners and more.'
  },
  bg_color: '#587E6F',
  text_color: '#FFFFFF'
}];
module.exports = {
  COMMERCE_CATEGORIES
};
